// extracted by mini-css-extract-plugin
export default {"landing":"Catalog_landing__9pGNZ","grid":"Catalog_grid__msSId","back__button":"Catalog_back__button__Ho-xj"};